module.exports = __webpack_public_path__ + "img/Female-active.62f7a10f.svg";